import React, { useEffect, useState } from "react";
import { getWeeklyAggregatedActivity } from "../../../services/apiservices/support";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card";
import Spinner from "../../../components/ui/spinner";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Bar,
  BarChart,
} from "recharts";

const DailyActivity = ({ timeRange }) => {
  const [support, setSupport] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setSupport(0);
    setLoading(true);
    getWeeklyAggregatedActivity(timeRange).then((data) => {
      setSupport(data);
      setLoading(false);
    });
  }, [timeRange]);

  return (
    <Card className="bg-white dark:bg-[#2c3440] p-24">
      <CardHeader className="p-24">
        <CardTitle>Daily Activity</CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <Spinner size="lg" />
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={support}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="day" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="logins" fill="#8884d8" name="Logins" />
              <Bar dataKey="tickets" fill="#82ca9d" name="Support Tickets" />
            </BarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
};
export default DailyActivity;
